module.exports = __webpack_public_path__ + "static/media/1.f80dfff2.jpg";